import clsx from "clsx";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";

import IconArrowRight1Active from "~/components/Icons/icon-arrow-right1-active";

import s from "./InfoSections.less";

type InfoSectionsProps = {
  title: string;
  sectionData: {
    label: string;
    value: string | string[];
  }[];
  subTitle?: string;
  accord?: boolean;
};

const InfoSections: React.FC<InfoSectionsProps> = ({
  title,
  sectionData,
  subTitle,
  accord = false,
}) => {
  const [imageUrls, setImageUrls] = useState<{ [key: string]: string }>({});
  const [open, setOpen] = useState<boolean>(true);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    const loadImage = async (url: string) => {
      const token = Cookies.get("token");
      if (!token || !url) return;

      try {
        const response = await fetch(url, {
          headers: {
            "x-authorization": `Bearer ${token}`,
          },
        });

        if (!response.ok) return;

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        setImageUrls((prev) => ({
          ...prev,
          [url]: objectUrl,
        }));
      } catch (error) {
        console.error("Error loading image:", error);
      }
    };

    sectionData.forEach(({ value }) => {
      if (Array.isArray(value)) {
        value.forEach((url) => {
          if (url && url.includes("/s3/view/")) {
            loadImage(url);
          }
        });
      } else if (typeof value === "string" && value.includes("/s3/view/")) {
        loadImage(value);
      }
    });

    return () => {
      Object.values(imageUrls).forEach((url) => URL.revokeObjectURL(url));
    };
  }, [sectionData]);

  return (
    <div className={clsx(s.wrapper, !open && s.wrapper_border)}>
      <div className={s.title}>
        <span>{title}</span>
        {accord && (
          <span
            onClick={() => setOpen(!open)}
            className={clsx(s.icon_wrapp, open ? s.open : s.close)}
          >
            <IconArrowRight1Active />
          </span>
        )}
      </div>
      {subTitle && <div className={s.subTitle}>{subTitle}</div>}

      {open &&
        sectionData?.map(({ label, value }, index) => (
          <div
            key={index}
            className={`${s.section} ${index === 0 ? s.firstSection : ""} ${
              Array.isArray(value) ||
              (typeof value === "string" && value.includes("/s3/view/"))
                ? s.imageSection
                : ""
            }`}
          >
            <div className={s.label}>{label}</div>
            <div className={s.value}>
              {Array.isArray(value) ? (
                <div className={s.imagesGrid}>
                  {value.map(
                    (imgSrc, idx) =>
                      imgSrc && (
                        <img
                          key={idx}
                          src={imageUrls[imgSrc] || imgSrc}
                          alt={`${label} ${idx + 1}`}
                          className={s.image}
                          onClick={() =>
                            setPreviewUrl(imageUrls[imgSrc] || imgSrc)
                          }
                        />
                      ),
                  )}
                </div>
              ) : typeof value === "string" && value.includes("/s3/view/") ? (
                <img
                  src={imageUrls[value] || value}
                  alt={label}
                  className={s.image}
                  onClick={() => setPreviewUrl(imageUrls[value] || value)}
                />
              ) : (
                value
              )}
            </div>
          </div>
        ))}
      {previewUrl && (
        <div className={s.modalBackdrop} onClick={() => setPreviewUrl(null)}>
          <button className={s.closeButton} onClick={() => setPreviewUrl(null)}>
            ✕
          </button>
          <div className={s.modalContent} onClick={(e) => e.stopPropagation()}>
            <img src={previewUrl} alt="Preview" className={s.modalImage} />
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoSections;
